import * as React from 'react'
import { ReactElement } from 'react'
import ReportForm from './ReportForm'
import { useFormikContext } from 'formik'
import { Stack } from '@fluentui/react'
import { DocumentGenerationType } from '../../../../hooks/document/useDocumentGenerationHandler'
import { FileStatus } from '../../../../config/fileConfig'
import UserPicker, { UserPickerProps } from '../../../TagPicker/UserPicker'
import FormikField from '../../../Formik/FormikField'
import { ReportFormType } from '../../../../pages/Finance/Reports'
import { FileFilterType } from '../../../../pages/File/BaseFileOverview'

export type FileClaimListReportDto = FileFilterType

function ReportBody(props: ReportFormType): ReactElement {
    const { values, setFieldValue } = useFormikContext<FileClaimListReportDto>()

    return (
        <Stack>
            <FormikField<UserPickerProps, FileClaimListReportDto>
                orientation={props.orientation}
                labelKey={'file.filter.owner'}
                fieldName={'ownerUsers'}
                component={UserPicker}
                componentProps={{
                    selectedOptions: values.ownerUsers,
                    onOptionsSelect: (_, selectedOptions) => setFieldValue('ownerUsers', selectedOptions),
                }}
            />
            <FormikField<UserPickerProps, FileClaimListReportDto>
                orientation={props.orientation}
                labelKey={'file.filter.executive'}
                fieldName={'executiveUsers'}
                component={UserPicker}
                componentProps={{
                    selectedOptions: values.executiveUsers,
                    onOptionsSelect: (_, selectedOptions) => setFieldValue('executiveUsers', selectedOptions),
                }}
            />
        </Stack>
    )
}

export default function FileClaimListReportForm(props: ReportFormType): ReactElement {
    return (
        <ReportForm<FileClaimListReportDto>
            title="Claim lijst"
            generationType={DocumentGenerationType.FileClaimListXls}
            initialValues={{
                ownerUsers: [],
                executiveUsers: [],
                statuses: [FileStatus.Open],
            }}
            {...props}
        >
            <ReportBody {...props} />
        </ReportForm>
    )
}
